<template>
  <div>
    <div class="profile-card-header">
      <div class="row">
        <div class="col-12 d-flex align-items-baseline">
          <h4
            v-text="title"
          />

          <div
            class="dropdown ml-auto d-flex align-items-baseline"
          >
            <BDropdown
              right
              no-caret
              variant="link"
              toggle-class="text-decoration-none p-0"
            >
              <template
                #button-content
              >
                <a
                  href="#"
                  aria-expanded="false"
                  class="title-color fs-13"
                >
                  {{ options[selected].name }}

                  <i class="fa fa-angle-down toggle-dropdown ml-1" />
                </a>
              </template>

              <BDropdownItem
                href="#"
                :key="index"
                v-for="(option, index) in options"
                @click.prevent="toggle(option, index)"
              >
                {{ __(option.name) }}
              </BDropdownItem>
            </BDropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="">
      <table class="table mb-0 table-sm">
        <tbody v-if="activities.length && ! loading">
          <tr
            :key="index"
            v-for="(activity, index) in activities"
          >
            <td><i :class="[activity.type.icon, 'mr-2 pl-3']" /> {{ activity.type.name }}</td>
            <td class="text-right">
              <span class="badge badge-white activity-total pr-3">
                {{ activity.total }}
              </span>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="loading">
          <tr>
            <td><i class="fa fa-circle-o-notch fa-spin" /></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td>
              <div
                class="col"
                v-if="title === 'Atividades Completadas'"
              >
                <span class="fs-13 light-gray">{{ __('Nenhuma atividade encontrada') }}.</span>
                <small
                  class="d-block light-gray"
                  style="font-size: 10px;"
                >{{ __('Tente mudar o filtro') }}</small>
                <div class="text-center pt-5">
                  <img
                    src="/build/icons/no-data.svg"
                    height="87px"
                  >
                </div>
              </div>
              <div
                class="col"
                v-else
              >
                <div class="row pb-2">
                  <div class="col-5">
                    <span class="fs-13 light-gray">{{ __('Nenhuma atividade encontrada') }}.</span>
                    <small
                      class="d-block light-gray"
                      style="font-size: 10px;"
                    >{{ __('Tente mudar o filtro') }}</small>
                  </div>
                  <img
                    class="ml-5"
                    src="/build/icons/no-data.svg"
                    height="87px"
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue';

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    options: {
      type: Array,
      required: true,
    },

    activities: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      required: true,
    },
  },

  data () {
    return {
      selected: 0,
    };
  },

  created () {
    this.$emit('toggle', this.options[this.selected]);
  },

  methods: {
    toggle (option, index) {
      this.$emit('toggle', option);
      this.selected = index;
    },
  },
};
</script>

<style lang="scss" scoped>
  select {
    border: none;
    color: #333;
    background: none;
  }

  table tr td,
  table tr td span {
    color: #857a98;
    border-top: 0;

    .activity-total {
      color: #857a98;
      font-size: 13px;
      letter-spacing: -0.2px;
      font-weight: 400;
    }
  }

  table tr {
    border-bottom: 1px solid #eae6f0;
  }

  table tr:last-child {
    border: 0;
  }
</style>
